
<div class="form--min-height bg-light-grey">
    <div class="container h-100 py-5 px-5">
        <div class="row mb-4 mb-lg-0">
            <div class="col-12">
                <div class="create-title fw-bold ff-spectral">
                    Create your account
                </div>
                <div class="text-primary fs-6">
                    Choose type of account and create an account
                </div>
            </div>

            <div class="col-12 col-lg-6" [hidden]="isAccount !== false">
                <div class="customer-account-main bg-white mt-5">
                    <div class="customer-account  p-md-5 p-3">
                        <div class="fs-6 text-center">
                            <img src="assets/images/create-user-icon.png" alt="" />
                            <h3 class="mt-3 mb-1">Customer Account</h3>
                            <p class="text-primary custom-minheight">Open a free loyalty account today and
                                start to enjoy the many perks!</p>
                        </div>
                        <div
                            class="customer-benefits mt-4 mb-5 text-center d-flex align-items-center justify-content-center">
                            <div class="common-block">
                                <img src="assets/images/discounts.png" alt="" />
                                <p>Free Samples</p>
                            </div>
                            <div class="common-block">
                                <img src="assets/images/rewards-cashback.png" alt="" />
                                <p>Rewards & Cashback</p>
                            </div>
                            <div class="common-block">
                                <img src="assets/images/free-delivery.png" alt="" />
                                <p>Nationwide Delivery</p>
                            </div>
                        </div>
                        <div class="create-btn-block text-center">
                            <button class="btn btn-wide btn-primary" (click)="toggleRegistration('customer')">Create
                                Account</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-6" [hidden]="isAccount !== false">
                <div class="customer-account-main bg-white mt-5">
                    <div class="trade-account p-md-5 p-3">
                        <div class="fs-6 text-center">
                            <img src="assets/images/create-trade-icon.png" alt="" />
                            <h3 class="mt-3 mb-1">Trade Account</h3>
                            <p class="text-primary custom-minheight">Open a free trade account today to
                                access all kinds of exclusive benefits &
                                discounts.</p>
                        </div>
                        <div
                            class="customer-benefits mt-4 mb-5 text-center d-flex align-items-center justify-content-center">
                            <div class="common-block">
                                <img src="assets/images/trade-discounts.png" alt="" />
                                <p>Instant 10% Discount</p>
                            </div>
                            <div class="common-block">
                                <img src="assets/images/trade-rewards.png" alt="" />
                                <p>Rewards & Cashback</p>
                            </div>
                            <div class="common-block">
                                <img src="assets/images/free-delivery.png" alt="" />
                                <p>Next Day AM Delivery</p>
                            </div>
                        </div>
                        <div class="create-btn-block text-center">
                            <button class="btn btn-wide btn-primary" (click)="toggleRegistration('trade')">Create
                                Account</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="col-12 card--min-height" [hidden]="isAccount !== true">
    <div class="bg-light h-100">
        <div class="d-flex flex-column justify-content-center align-items-center bg-light h-100 p-3 pt-md-0 px-lg-4 px-xl-5 pb-0">
            <div class="d-flex flex-column w-100 bg-white form-inner-main">
                <div>
                    <ng-container *ngIf="accountType === 'customer' && !user">
                        <div class="customer-account-main customer-trade-form-main">
                            <div
                                class="customer-account account-form-heading  d-flex justify-content-between align-items-center px-4 py-4">
                                <div class="fs-6 d-flex justify-content-between align-items-center">
                                    <div class="icon-block">
                                        <img src="assets/images/create-user-icon.png" alt="" />
                                    </div>
                                    <div class="customer-open">
                                        <h3 class="mt-0 mb-0">Customer Account</h3>
                                        <p class="text-primary custom-minheight">Open a free loyalty
                                            account today and
                                            start to enjoy the many perks!</p>
                                    </div>
                                </div>
                                <div
                                    class="customer-benefits text-center d-flex align-items-center justify-content-center">
                                    <div class="common-block">
                                        <img src="assets/images/discounts.png" alt="" />
                                        <p>Free Samples</p>
                                    </div>
                                    <div class="common-block">
                                        <img src="assets/images/rewards-cashback.png" alt="" />
                                        <p>Rewards & Cashback</p>
                                    </div>
                                    <div class="common-block">
                                        <img src="assets/images/free-delivery.png" alt="" />
                                        <p>Nationwide Delivery</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="accountType === 'trade'">
                        <div class="customer-account-main customer-trade-form-main">
                            <div
                                class="customer-account account-form-heading  d-flex justify-content-between align-items-center px-4 py-4">
                                <div class="fs-6 d-flex justify-content-between align-items-center">
                                    <div class="icon-block">
                                        <img src="assets/images/create-user-icon.png" alt="" />
                                    </div>
                                    <div class="customer-open">
                                        <h3 class="mt-0 mb-0">Trade Account</h3>
                                        <p class="text-primary custom-minheight">Open a free trade account today to access all kinds of exclusive benefits & discounts.</p>
                                    </div>
                                </div>
                                <div
                                    class="customer-benefits text-center d-flex align-items-center justify-content-center">
                                    <div class="common-block">
                                        <img src="assets/images/trade-discounts.png" alt="" />
                                        <p>Instant 10% Discount</p>
                                    </div>
                                    <div class="common-block">
                                        <img src="assets/images/trade-rewards.png" alt="" />
                                        <p>Rewards & Cashback</p>
                                    </div>
                                    <div class="common-block">
                                        <img src="assets/images/free-delivery.png" alt="" />
                                        <p>Next Day AM Delivery</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="col-12 card--min-height bg-white" [hidden]="isAccount !== true">
    <div class="bg-light p-3 pt-md-0 px-lg-4 px-xl-5 pb-0 pt-0 h-100 pb-5">
        <div
            class="d-flex flex-column justify-content-center align-items-center bg-white h-100 p-3 p-lg-4 p-xl-5 card-main-block">
            <div class="card--max-width w-100">
                <app-registration-form [hidden]="accountType !== 'customer'" [userFromStorage]="user"
                    [regPromoCode]="regPromoCode" [referralCode]="referralCode"
                    (registrationComplete)="registered($event)"></app-registration-form>
                <app-trade-account-registration-form [hidden]="accountType !== 'trade'"
                    [regPromoCode]="regPromoCode">
                </app-trade-account-registration-form>
            </div>
        </div>
    </div>
</div>
<app-contact-cta></app-contact-cta>
